import { render, staticRenderFns } from "./v-anchor.vue?vue&type=template&id=9608070e&scoped=true&"
import script from "./v-anchor.vue?vue&type=script&lang=js&"
export * from "./v-anchor.vue?vue&type=script&lang=js&"
import style0 from "./v-anchor.vue?vue&type=style&index=0&id=9608070e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9608070e",
  null
  
)

export default component.exports